import { FunnelIcon } from '@heroicons/react/20/solid';

import NoShowShiftCard from '../components/NoShowShiftCard';
import useNoShowQueue from '../hooks/useNoShowQueue';

import LoadingState from '@/components/LoadingState';

// No-show queue tab: a "No show" title + Show control, then a card per shift
// with its outstanding no-show worker(s). Data comes from
// /api/admin/dashboard_v2/no_show.

type Props = { agencyId: number };

const NoShowTab = ({ agencyId }: Props) => {
  const { data, isLoading, isError } = useNoShowQueue(agencyId);
  const shifts = data?.shifts ?? [];

  return (
    <div>
      <div className="dashv2-queue-title">
        <h2 className="dashv2-queue-heading">No show</h2>
        {/* Filtering the queue is a follow-up; the control is shown for parity
            with the Figma. */}
        <button type="button" className="dashv2-showbtn" disabled>
          <FunnelIcon />
          Show
        </button>
      </div>

      {isLoading && !data ? (
        <LoadingState />
      ) : isError ? (
        <div className="dashv2-queue-empty">
          Unable to load the no-show queue. Please retry.
        </div>
      ) : shifts.length === 0 ? (
        <div className="dashv2-queue-empty">No outstanding no-shows. 🎉</div>
      ) : (
        <div className="dashv2-queue-list">
          {shifts.map((shift) => (
            <NoShowShiftCard key={shift.shift_id} shift={shift} />
          ))}
        </div>
      )}
    </div>
  );
};

export default NoShowTab;
